var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoteles28X28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 4.66668C2.625 2.90009 4.06675 1.45834 5.83333 1.45834H22.1667C23.9332 1.45834 25.375 2.90009 25.375 4.66668V23.3333C25.375 25.0999 23.9332 26.5417 22.1667 26.5417H19.4833C17.7168 26.5417 16.275 25.0999 16.275 23.3333V19.8217C16.275 19.6633 16.1417 19.53 15.9833 19.53H12.005C11.8466 19.53 11.7133 19.6633 11.7133 19.8217V23.3333C11.7133 25.0999 10.2716 26.5417 8.505 26.5417H5.83333C4.06675 26.5417 2.625 25.0999 2.625 23.3333V4.66668ZM5.83333 3.20834C5.03325 3.20834 4.375 3.86659 4.375 4.66668V23.3333C4.375 24.1334 5.03325 24.7917 5.83333 24.7917H8.505C9.30508 24.7917 9.96333 24.1334 9.96333 23.3333V19.8217C9.96333 18.6968 10.8801 17.78 12.005 17.78H15.9833C17.1082 17.78 18.025 18.6968 18.025 19.8217V23.3333C18.025 24.1334 18.6832 24.7917 19.4833 24.7917H22.1667C22.9668 24.7917 23.625 24.1334 23.625 23.3333V4.66668C23.625 3.86659 22.9668 3.20834 22.1667 3.20834H5.83333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0972 6.12501C15.0972 5.64176 15.489 5.25001 15.9722 5.25001H20.1489C20.6321 5.25001 21.0239 5.64176 21.0239 6.12501C21.0239 6.60826 20.6321 7.00001 20.1489 7.00001H15.9722C15.489 7.00001 15.0972 6.60826 15.0972 6.12501Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97721 6.12501C6.97721 5.64176 7.36896 5.25001 7.85221 5.25001H12.0289C12.5121 5.25001 12.9039 5.64176 12.9039 6.12501C12.9039 6.60826 12.5121 7.00001 12.0289 7.00001H7.85221C7.36896 7.00001 6.97721 6.60826 6.97721 6.12501Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0972 9.4148C15.0972 8.93156 15.489 8.5398 15.9722 8.5398H20.1489C20.6321 8.5398 21.0239 8.93156 21.0239 9.4148C21.0239 9.89805 20.6321 10.2898 20.1489 10.2898H15.9722C15.489 10.2898 15.0972 9.89805 15.0972 9.4148Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97721 9.4148C6.97721 8.93156 7.36896 8.5398 7.85221 8.5398H12.0289C12.5121 8.5398 12.9039 8.93156 12.9039 9.4148C12.9039 9.89805 12.5121 10.2898 12.0289 10.2898H7.85221C7.36896 10.2898 6.97721 9.89805 6.97721 9.4148Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0972 12.7052C15.0972 12.2219 15.489 11.8302 15.9722 11.8302H20.1489C20.6321 11.8302 21.0239 12.2219 21.0239 12.7052C21.0239 13.1884 20.6321 13.5802 20.1489 13.5802H15.9722C15.489 13.5802 15.0972 13.1884 15.0972 12.7052Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97721 12.7052C6.97721 12.2219 7.36896 11.8302 7.85221 11.8302H12.0289C12.5121 11.8302 12.9039 12.2219 12.9039 12.7052C12.9039 13.1884 12.5121 13.5802 12.0289 13.5802H7.85221C7.36896 13.5802 6.97721 13.1884 6.97721 12.7052Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoteles28X28);
export default __webpack_public_path__ + "static/media/HOTELES_28X28.89b1fc6ada70aad95f57fcdc3e378053.svg";
export { ForwardRef as ReactComponent };